import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Footer from "../components/layout/Footer";
import {
  Users,
  BookOpen,
  Trophy,
  MessageCircle,
  UserPlus,
  LogIn,
} from "lucide-react";

export default function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;

    const storedRole = localStorage.getItem("userRole");
    if (storedRole === "teacher") {
      navigate("/TeacherDashboard");
    } else if (storedRole === "student") {
      navigate("/StudentDashboard");
    } else {
      navigate("/StudentDashboard");
    }
  }, [navigate]);

  return (
    <div
      className="min-vh-100 d-flex flex-column home-page-wrapper"
      style={{
        overflowX: "hidden",
      }}
    >
      <Container className="py-5 flex-grow-1">
        {/* Hero Section */}
        <div className="text-center mb-5">
          <div className="d-flex justify-content-center align-items-center gap-3 mb-4">
            <h1 className="display-1 text-primary fw-bold">fintogo</h1>
          </div>

          <div className="mb-4">
            <h2 className="display-4 fw-bold text-dark">
              Wirtschaft einfach lernen.
            </h2>
            <p className="lead text-secondary">Lerne schlauer, nicht härter.</p>
          </div>

          <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
            <Link
              to="/register"
              className="btn btn-primary px-5 btn-lg d-flex align-items-center justify-content-center"
            >
              <UserPlus className="me-2" size={20} />
              Registrieren
            </Link>
            <Link
              to="/Login"
              className="btn btn-outline-primary px-5 btn-lg d-flex align-items-center justify-content-center"
            >
              <LogIn className="me-2" size={20} />
              Login
            </Link>
          </div>
        </div>

        {/* Features Grid */}
        <Row xs={1} md={2} lg={4} className="g-4 mb-5">
          <Col>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="text-center">
                <div
                  className="bg-primary bg-opacity-10 rounded-3 mx-auto mb-3 d-flex justify-content-center align-items-center"
                  style={{ width: 48, height: 48 }}
                >
                  <BookOpen className="text-primary" size={24} />
                </div>
                <Card.Title className="fs-5 fw-semibold text-dark">
                  Lektionen
                </Card.Title>
                <Card.Text className="text-muted small">
                  Strukturierte Lerninhalte
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="text-center">
                <div
                  className="bg-success bg-opacity-10 rounded-3 mx-auto mb-3 d-flex justify-content-center align-items-center"
                  style={{ width: 48, height: 48 }}
                >
                  <Trophy className="text-success" size={24} />
                </div>
                <Card.Title className="fs-5 fw-semibold text-dark">
                  Quiz
                </Card.Title>
                <Card.Text className="text-muted small">
                  Interaktive Tests
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="text-center">
                <div
                  className="bg-primary bg-opacity-10 rounded-3 mx-auto mb-3 d-flex justify-content-center align-items-center"
                  style={{ width: 48, height: 48 }}
                >
                  <MessageCircle className="text-primary" size={24} />
                </div>
                <Card.Title className="fs-5 fw-semibold text-dark">
                  AI Tutor
                </Card.Title>
                <Card.Text className="text-muted small">
                  Intelligente Hilfe
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>

          <Col>
            <Card className="h-100 border-0 shadow-sm">
              <Card.Body className="text-center">
                <div
                  className="bg-success bg-opacity-10 rounded-3 mx-auto mb-3 d-flex justify-content-center align-items-center"
                  style={{ width: 48, height: 48 }}
                >
                  <Users className="text-success" size={24} />
                </div>
                <Card.Title className="fs-5 fw-semibold text-dark">
                  Klassen
                </Card.Title>
                <Card.Text className="text-muted small">
                  Schülerverwaltung
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Info Section */}
        <div className="mb-5">
          <h3 className="fw-bold text-dark mb-4">
            Modernes Lernen für die nächste Generation
          </h3>
          <Row className="g-4">
            <Col md={4}>
              <div className="d-flex align-items-start gap-3">
                <div
                  className="bg-primary rounded d-flex justify-content-center align-items-center flex-shrink-0"
                  style={{ width: 48, height: 48 }}
                >
                  <BookOpen className="text-white" size={24} />
                </div>
                <div>
                  <h5 className="fw-semibold mb-1">Strukturierte Lektionen</h5>
                  <p className="mb-0 text-muted">
                    Aufeinander aufbauende Lerninhalte für optimalen Fortschritt.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4}>
              <div className="d-flex align-items-start gap-3">
                <div
                  className="bg-success rounded d-flex justify-content-center align-items-center flex-shrink-0"
                  style={{ width: 48, height: 48 }}
                >
                  <Trophy className="text-white" size={24} />
                </div>
                <div>
                  <h5 className="fw-semibold mb-1">Gamification</h5>
                  <p className="mb-0 text-muted">
                    Punkte, Level und Belohnungen motivieren zum Lernen.
                  </p>
                </div>
              </div>
            </Col>

            <Col md={4}>
              <div className="d-flex align-items-start gap-3">
                <div
                  className="bg-primary rounded d-flex justify-content-center align-items-center flex-shrink-0"
                  style={{ width: 48, height: 48 }}
                >
                  <MessageCircle className="text-white" size={24} />
                </div>
                <div>
                  <h5 className="fw-semibold mb-1">AI-Unterstützung</h5>
                  <p className="mb-0 text-muted">
                    Persönlicher AI-Assistent für individuelle Fragen.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <Footer noSidebar={true}/>
    </div>
  );
}
